(function () {
  function init(section) {
    var viewport = section.querySelector('[data-viewport]');
    var track = section.querySelector('[data-track]');
    if (!viewport || !track) return;
    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-slide]'));
    var dots = Array.prototype.slice.call(section.querySelectorAll('[data-dot-index]'));
    if (!slides.length) return;

    var autoplaySeconds = parseFloat(section.dataset.autoplay) || 0;
    var autoplayTimer = null;
    var isDragging = false;
    var dragStartX = 0;
    var dragStartScroll = 0;
    var dragMoved = false;
    var rafId = null;

    function updateActiveStates() {
      var viewportRect = viewport.getBoundingClientRect();
      var viewportCenter = viewportRect.left + viewportRect.width / 2;
      var closestIndex = 0;
      var closestDistance = Infinity;

      slides.forEach(function (slide, index) {
        var rect = slide.getBoundingClientRect();
        var slideCenter = rect.left + rect.width / 2;
        var distance = Math.abs(slideCenter - viewportCenter);
        var normalized = Math.min(1, distance / (viewportRect.width / 2));

        slide.style.setProperty('--hoad-slide-scale', (1 - normalized * 0.14).toFixed(3));
        slide.style.setProperty('--hoad-slide-opacity', (1 - normalized * 0.5).toFixed(3));
        slide.classList.toggle('is-active', normalized < 0.15);

        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      dots.forEach(function (dot, index) {
        dot.classList.toggle('is-active', index === closestIndex);
      });

      return closestIndex;
    }

    function onScroll() {
      if (rafId) return;
      rafId = requestAnimationFrame(function () {
        updateActiveStates();
        rafId = null;
      });
    }

    viewport.addEventListener('scroll', onScroll, { passive: true });

    function scrollToSlide(index, smooth) {
      index = Math.max(0, Math.min(slides.length - 1, index));
      var slide = slides[index];
      var target = slide.offsetLeft + slide.offsetWidth / 2 - viewport.clientWidth / 2;
      viewport.scrollTo({ left: target, behavior: smooth === false ? 'auto' : 'smooth' });
    }

    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        stopAutoplay();
        scrollToSlide(index);
        restartAutoplay();
      });
    });

    // Mouse drag-to-scroll (touch already scrolls natively via overflow-x)
    viewport.addEventListener('mousedown', function (e) {
      isDragging = true;
      dragMoved = false;
      dragStartX = e.clientX;
      dragStartScroll = viewport.scrollLeft;
      viewport.classList.add('is-dragging');
      stopAutoplay();
    });

    window.addEventListener('mousemove', function (e) {
      if (!isDragging) return;
      var delta = e.clientX - dragStartX;
      if (Math.abs(delta) > 4) dragMoved = true;
      viewport.scrollLeft = dragStartScroll - delta;
    });

    window.addEventListener('mouseup', function () {
      if (!isDragging) return;
      isDragging = false;
      viewport.classList.remove('is-dragging');
      var nearest = updateActiveStates();
      scrollToSlide(nearest);
      restartAutoplay();
    });

    // Sem isso o navegador arrasta o link/foto (fantasma) em vez de rolar o carrossel.
    viewport.addEventListener('dragstart', function (e) {
      e.preventDefault();
    });

    viewport.addEventListener('click', function (e) {
      if (dragMoved) {
        e.preventDefault();
        dragMoved = false;
      }
    });

    viewport.addEventListener('touchstart', stopAutoplay, { passive: true });
    viewport.addEventListener('touchend', function () {
      setTimeout(function () {
        var nearest = updateActiveStates();
        scrollToSlide(nearest);
      }, 50);
      restartAutoplay();
    });

    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    function restartAutoplay() {
      if (!autoplaySeconds) return;
      var reducedMotion = window.HoadMotion ? window.HoadMotion.reducedMotion() : window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reducedMotion) return;
      stopAutoplay();
      autoplayTimer = setInterval(function () {
        var current = updateActiveStates();
        var next = current + 1 >= slides.length ? 0 : current + 1;
        scrollToSlide(next);
      }, autoplaySeconds * 1000);
    }

    section.addEventListener('mouseenter', stopAutoplay);
    section.addEventListener('mouseleave', restartAutoplay);

    updateActiveStates();
    restartAutoplay();
  }

  function boot() {
    document.querySelectorAll('[data-hoad-showcase]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('[data-hoad-showcase]');
    if (section) init(section);
  });
})();
